<template>
  <pt-policy-manage class="pt-policy-manage__withData" @deletePolicy="deletePolicy" ref="table"></pt-policy-manage>
</template>

<script>
import PtPolicyManage from './index'
export default {
  name: 'pt-policy-manage__withData',
  components: {
    'pt-policy-manage': PtPolicyManage
  },
  methods: {
    deletePolicy (data, id) {
      this.$store.dispatch(data.apiUrl, id).then(res => {
        this.$message.success('删除' + data.name + '成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除' + data.name + '失败')
      })
    }
  },
  created () {
  }
}
</script>
